import React from 'react'
import styles from '../../styles'
import { makeStyles } from 'tss-react/mui'
import { DialogContent, DialogTitle, Dialog as MuiDialog } from '@mui/material'

const useStyle = makeStyles<{ isMenuMobile: boolean }>()((theme, { isMenuMobile }) => ({
	...styles(theme),
	dialogRootStyle: {
		padding: '8px 24px',
		backgroundColor: isMenuMobile ? theme.palette.blue.main : '',
		'&:first-child': {
			paddingTop: 20
		}
	},
	noPaddingDialogRootStyle: {
		padding: 0,
		backgroundColor: isMenuMobile ? theme.palette.blue.main : '',
		'&:first-child': {
			paddingTop: 0
		}
	},
	backDrop: {
		background: 'rgba(0, 0, 0, 0.5)'
	}
}))

interface AcceptingProps {
	onCloseDialog: () => void,
	open: boolean,
	children: React.ReactChild,
	title?: string,
	fullScreen?: boolean,
	maxWidth?: false | 'sm' | 'xs' | 'md' | 'lg' | 'xl' | undefined,
	withPadding?: boolean,
	isMenuMobile?: boolean,
	dialogStyle?: string,
	className?: string
}

type DialogProps = AcceptingProps

const Dialog: React.FC<DialogProps> = (
	{
		onCloseDialog,
		open,
		children,
		title,
		fullScreen = true,
		maxWidth = 'sm',
		withPadding = true,
		isMenuMobile = false,
		dialogStyle,
		className
	}
) => {
	const { classes } = useStyle({ isMenuMobile })

	const handleClose = () => {
		onCloseDialog()
	}
	return (
		<MuiDialog
			open={open}
			onClose={handleClose}
			fullScreen={fullScreen}
			maxWidth={maxWidth}
			BackdropProps={{
				classes: {
					root: classes.backDrop
				}
			}}
			className={className}
		>
			{
				title &&
				<DialogTitle>
					{title}
				</DialogTitle>
			}
			<DialogContent
				classes={{
					root: withPadding ? classes.dialogRootStyle : classes.noPaddingDialogRootStyle
				}}
				className={dialogStyle}
			>
				{children}
			</DialogContent>
		</MuiDialog>
	)
}

export default Dialog
